export default "__VITE_ASSET__Cou2eBhg__"